import { russianMessages } from "@/i18n/messages/ru"

const englishOverrides: Record<string, string> = {
  "status.ACTIVE": "Active",
  "status.PAID": "Paid",
  "status.SYNCED": "Synced",
  "status.SUCCEEDED": "Succeeded",
  "status.SENT": "Sent",
  "status.UP": "Up",
  "status.AUTHENTICATED": "Authenticated",
  "status.COMPLETED": "Completed",
  "status.CURRENT": "Current",
  "status.VERIFIED": "Verified",
  "status.MFA_VERIFIED": "MFA verified",
  "status.STANDARD": "Standard",
  "status.PENDING": "Pending",
  "status.CREATING": "Creating",
  "status.RUNNING": "Running",
  "status.DEGRADED": "Degraded",
  "status.STALE": "Stale",
  "status.PENDING_VERIFICATION": "Pending verification",
  "status.DELETION_PENDING": "Deletion pending",
  "status.FAILED": "Failed",
  "status.DEAD": "Dead",
  "status.DOWN": "Down",
  "status.LOCKED": "Locked",
  "status.SUSPENDED": "Suspended",
  "status.ANONYMIZED": "Anonymized",
  "status.RATE_LIMITED": "Rate limited",
  "status.REFUNDED": "Refunded",
  "status.REVOKED": "Revoked",
  "status.CANCELLED": "Cancelled",
  "status.EXPIRED": "Expired",
  "status.PENDING_REVOCATION": "Pending revocation",
  "status.NEVER": "Never",
  "status.INVALID": "Invalid",
  "status.VALID": "Valid",
  "status.UNKNOWN": "Unknown",
  "status.ENABLED": "Enabled",
  "status.DISABLED": "Disabled",
  "status.INACTIVE": "Inactive",
  "status.SENDING": "Sending",
  "status.NOT_REQUIRED": "Not required",
  "status.PAYMENT_CREDIT": "Payment credit",
  "status.ADMIN_CREDIT": "Admin credit",
  "status.ADMIN_DEBIT": "Admin debit",
  "status.REFUND_DEBIT": "Refund debit",
  "status.CHARGEBACK_DEBIT": "Chargeback debit",
  "status.PROMOTIONAL_CREDIT": "Promotional credit",
  "status.CORRECTION_CREDIT": "Correction credit",
  "status.CORRECTION_DEBIT": "Correction debit",
  "enum.RESPONSES": "Responses",
  "enum.CHAT_COMPLETIONS": "Chat completions",
  "enum.STREAMING": "Streaming",
  "enum.TOOLS": "Tools",
  "enum.VISION": "Vision",
  "enum.REASONING": "Reasoning",
  "enum.CREATED_AT": "Created at",
  "enum.EMAIL": "Email",
  "enum.DISPLAY_NAME": "Display name",
  "enum.AVAILABLE_BALANCE": "Available balance",
  "enum.BILLABLE_SPEND": "Billable spend",
  "enum.LAST_LOGIN_AT": "Last login",
  "enum.LAST_REQUEST_AT": "Last request",
  "enum.REQUESTS": "Requests",
  "enum.TOKENS": "Tokens",
  "enum.BILLED_COST": "Billed cost",
  "enum.BASE_COST": "Base cost",
  "enum.ERRORS": "Errors",
  "enum.CREDIT": "Credit",
  "enum.DEBIT": "Debit",
  "enum.LITELLM_USER": "LiteLLM user",
  "enum.BUDGET": "Budget",
  "enum.API_KEYS": "API keys",
  "enum.USAGE": "Usage",
  "role.CUSTOMER": "Customer",
  "role.SUPPORT": "Support",
  "role.ADMIN": "Admin",
  "role.SUPER_ADMIN": "Super admin",
}

export const englishMessages: Record<string, string> = {
  ...Object.fromEntries(Object.keys(russianMessages).map((key) => [key, key])),
  ...englishOverrides,
}
